import { Box, Typography } from '@mui/material';

export interface StatisticDetailRow {
  label: string;
  value: string;
}

interface StatisticDetailPopupProps {
  accentHex: string;
  rows: StatisticDetailRow[];
}

function StatisticDetailPopup({ accentHex, rows }: StatisticDetailPopupProps) {
  return (
    <Box
      className='box-border rounded-xl border-2 border-solid bg-white p-3 shadow-[0_8px_24px_rgba(15,23,42,0.1)]'
      sx={{
        borderColor: accentHex,
        fontFamily: '"Manrope", sans-serif',
      }}
    >
      <Box className='flex flex-col gap-2'>
        {rows.map((row, idx) => (
          <Box
            key={`${idx}-${row.label}`}
            className='grid w-full grid-cols-[minmax(0,1fr)_auto] items-start gap-x-2 gap-y-0.5'
          >
            <Typography
              component='span'
              className='min-w-0 text-sm font-normal leading-[140%] text-[#7B8794]'
              sx={{ fontFamily: 'inherit' }}
            >
              {row.label}
            </Typography>
            <Typography
              component='span'
              className='shrink-0 text-right text-sm font-bold leading-[140%]'
              sx={{ fontFamily: 'inherit', color: accentHex }}
            >
              {row.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default StatisticDetailPopup;
